import { createContext, use } from 'react';

/**
 * Contorul din navigatie: cate articole sunt in cos.
 *
 * `null` inseamna "inca nu se stie" si NU se deseneaza. Un zero afisat inainte
 * de a primi raspunsul e o minciuna scurta, dar suficienta cat sa nu se uite
 * omul in cos.
 *
 * A fost si un contor de aprobari aici. A plecat odata cu ecranul: aprobarea e
 * o mutare de stare pe tichet, iar un numar de tichete care asteapta decizia
 * cuiva se vede in platforma, pe cozile de tichete, nu langa cosul de cumparaturi.
 */
export interface CountsApi {
  cart: number | null;
  refreshCart: () => void;
  /**
   * Cate cereri are omul in total - cererile de magazin si tichetele directe
   * la un loc, exact ce numara si ecranul „Cererile mele" cand se deschide
   * fara filtru.
   *
   * `null` la fel ca la cos: pana se stie, nu se deseneaza nimic.
   */
  requests: number | null;
  refreshRequests: () => void;
  /**
   * La cate tichete ti-a raspuns echipa fara sa fi deschis tichetul de atunci.
   *
   * Se socoteste in browser, comparand `last_staff_comment_id` primit de la
   * api cu ce s-a vazut - vezi `lib/replies` pentru de ce nu pe server.
   */
  newReplies: number | null;
}

export const CountsContext = createContext<CountsApi | null>(null);

export function useCounts(): CountsApi {
  const value = use(CountsContext);
  if (!value) throw new Error('useCounts used outside CountsProvider');
  return value;
}
